import React from 'react';
import styles from './styles.module.css';

type Props = {
  children: React.ReactNode;
};

function BigScreenList({ children }: Props) {
  return <div className={styles.bigScreenList}>{children}</div>;
}

export default BigScreenList;
